import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://orgi-api.sconexsoft.com/orgi/',
  // baseURL: 'http://100.42.188.112:9090',
  // baseURL:'http://192.168.29.115:8093'
  // baseURL: 'http://100.42.188.112:8093',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add Authorization token
apiClient.interceptors.request.use(
  (config) => {
    // Skip adding token for public endpoints (e.g., login and register)
    const publicEndpoints = ['/api/auth', '/api/register'];
    if (!publicEndpoints.includes(config.url)) {
      const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling errors globally (optional)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle global errors, e.g., 401 Unauthorized
    if (error.response?.status === 401) {
      // Optionally clear storage and redirect to login
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');
      window.location.href = '/auth/signin';
    }
    return Promise.reject(error);
  }
);

export default apiClient;